module.exports = __webpack_public_path__ + "img/Austrian.999c916a.svg";